module.exports = __webpack_public_path__ + "img/banner-07z.a3f14c15.png";